<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-select-input
    id="cargoLocation"
    name="cargoLocation"
    label="Location"
    [options]="locations"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('cargoLocation')"
    [readonly]="isFieldReadOnly('cargoLocation')"
    [value]="operationalStore.operatingConditions?.()?.cargoLocation?.value"
    [ngModel]="operationalStore.operatingConditions?.()?.cargoLocation?.value"
  />
  <nsp-number-input
    id="tugsAllFast"
    name="tugsAllFast"
    label="Tugs All Fast"
    [unit]="'Tugs'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('tugsAllFast')"
    [readonly]="isFieldReadOnly('tugsAllFast')"
    [value]="operationalStore.operatingConditions?.()?.tugsAllFast?.value"
    [ngModel]="operationalStore.operatingConditions?.()?.tugsAllFast?.value"
  />
  <nsp-number-input
    id="tugsLastLine"
    name="tugsLastLine"
    label="Tugs Last Line"
    [unit]="'Tugs'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('tugsLastLine')"
    [readonly]="isFieldReadOnly('tugsLastLine')"
    [value]="operationalStore.operatingConditions?.()?.tugsLastLine?.value"
    [ngModel]="operationalStore.operatingConditions?.()?.tugsLastLine?.value"
  />
  <nsp-number-input
    id="draughtForward"
    name="draughtForward"
    label="Draught Forward"
    [unit]="'m'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('draughtForward')"
    [readonly]="isFieldReadOnly('draughtForward')"
    [value]="operationalStore.operatingConditions?.()?.draughtForward?.value"
    [ngModel]="operationalStore.operatingConditions?.()?.draughtForward?.value"
  />
  <nsp-number-input
    id="draughtAft"
    name="draughtAft"
    label="Draught Aft"
    [unit]="'m'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('draughtAft')"
    [readonly]="isFieldReadOnly('draughtAft')"
    [value]="operationalStore.operatingConditions?.()?.draughtAft?.value"
    [ngModel]="operationalStore.operatingConditions?.()?.draughtAft?.value"
  />
  <nsp-number-input
    id="trim"
    name="trim"
    label="Trim"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('trim')"
    [readonly]="isFieldReadOnly('trim')"
    [value]="operationalStore.vm().trim()"
    [ngModel]="operationalStore.vm().trim()"
  />
  <nsp-number-input
    id="ballastWaterOnBoard"
    name="ballastWaterOnBoard"
    label="Ballast Water on Board"
    [unit]="'MT'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('ballastWaterOnBoard')"
    [readonly]="isFieldReadOnly('ballastWaterOnBoard')"
    [value]="
      operationalStore.operatingConditions?.()?.ballastWaterOnBoard?.value
    "
    [ngModel]="
      operationalStore.operatingConditions?.()?.ballastWaterOnBoard?.value
    "
  />
  <nsp-number-input
    id="ballastWaterIntake"
    name="ballastWaterIntake"
    label="Ballast Water Intake"
    [unit]="'MT'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('ballastWaterIntake')"
    [readonly]="isFieldReadOnly('ballastWaterIntake')"
    [value]="
      operationalStore.operatingConditions?.()?.ballastWaterIntake?.value
    "
    [ngModel]="
      operationalStore.operatingConditions?.()?.ballastWaterIntake?.value
    "
  />
  <nsp-number-input
    id="ballastWaterDischarged"
    name="ballastWaterDischarged"
    label="Ballast Water Discharged"
    [unit]="'MT'"
    [min]="0"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('ballastWaterDischarged')"
    [readonly]="isFieldReadOnly('ballastWaterDischarged')"
    [value]="
      operationalStore.operatingConditions?.()?.ballastWaterDischarged?.value
    "
    [ngModel]="
      operationalStore.operatingConditions?.()?.ballastWaterDischarged?.value
    "
  />
  <nsp-calendar-input
    id="ballastWaterSampleDate"
    name="ballastWaterSampleDate"
    label="Ballast Water Sample Date"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('ballastWaterSampleDate')"
    [readonly]="isFieldReadOnly('ballastWaterSampleDate')"
    [value]="
      operationalStore.operatingConditions?.()?.ballastWaterSampleDate?.value
    "
    [ngModel]="
      operationalStore.operatingConditions?.()?.ballastWaterSampleDate?.value
    "
  />
  <nsp-number-input
    id="ballastWaterCountOfCells"
    name="ballastWaterCountOfCells"
    label="Ballast Water Count of Cells"
    description="10-50 micron"
    [unit]="'Cells/ml'"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('ballastWaterCountOfCells')"
    [readonly]="isFieldReadOnly('ballastWaterCountOfCells')"
    [value]="
      operationalStore.operatingConditions?.()?.ballastWaterCountOfCells?.value
    "
    [ngModel]="
      operationalStore.operatingConditions?.()?.ballastWaterCountOfCells?.value
    "
  />
</form>
